import { render } from "./ArtworkIdentifiers.vue?vue&type=template&id=025d573e&scoped=true"
import script from "./ArtworkIdentifiers.vue?vue&type=script&lang=js"
export * from "./ArtworkIdentifiers.vue?vue&type=script&lang=js"

import "./ArtworkIdentifiers.vue?vue&type=style&index=0&id=025d573e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025d573e"]])

export default __exports__